import Image from "next/image";
import { FaApple, FaEnvelope } from "react-icons/fa6";
import styles from "./AuthButton.module.scss";

const PROVIDERS = {
  google: {
    label: "Continue with Google",
    iconType: "image",
    icon: "/assets/img/icons/google.svg",
  },
  facebook: {
    label: "Continue with Facebook",
    iconType: "image",
    icon: "/assets/img/icons/facebook.svg",
  },
  apple: {
    label: "Continue with Apple",
    iconType: "icon",
    icon: FaApple,
  },
  email: {
    label: "Continue with Email",
    iconType: "icon",
    icon: FaEnvelope,
  },
};

export default function AuthButton({
  provider,
  onClick,
  type = "button",
  disabled = false,
  className,
}) {
  const config = PROVIDERS[provider];

  if (!config) {
    return null;
  }

  const Icon = config.icon;

  return (
    <button
      type={type}
      className={`${styles.button} ${styles[provider]} ${className ?? ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      <span className={`${styles.iconSlot}`}>
        {config.iconType === "image" ? (
          <Image
            src={Icon}
            alt=""
            width={24}
            height={24}
            className={styles.iconImage}
            aria-hidden="true"
          />
        ) : (
          <Icon className={`${styles.icon}`} />
        )}
      </span>
      <span className={`${styles.label}`}>{config.label}</span>
      <span className={`${styles.iconSlot}`} aria-hidden="true" />
    </button>
  );
}
